<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="items"
    :server-items-length="meta.total"
    :footer-props="footerProps"
    :options="options"
    :page="page"
    :items-per-page="itemsPerPage"
    :sort-by="sortBy"
    :sort-desc="sortDesc"
    :multi-sort="multiSort"
    v-on="listeners"
  >
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | dateFormat }}
    </template>

    <template v-slot:item.type_id="{ item }">
      <div v-if="!isEmptyObject(item.type)">
        <v-chip
          v-if="item.type.color"
          :color="item.type.color"
          text-color="white"
        >
          {{ item.type.name }}
        </v-chip>
        <div v-else>
          {{ item.type.name }}
        </div>
      </div>
      <div v-else>
        {{ item.type }}
      </div>
    </template>

    <template v-slot:item.source_id="{ item }">
      {{ item.source.name }}
    </template>

    <template v-slot:item.status_id="{ item }">
      <div v-if="!isEmptyObject(item.status)">
        <v-chip
          v-if="item.status.color"
          :color="item.status.color"
          text-color="white"
        >
          {{ item.status.name }}
        </v-chip>
        <div v-else>
          {{ item.status.name }}
        </div>
      </div>
      <div v-else>
        {{ item.status }}
      </div>
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('show', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { isEmpty } from 'lodash';
import listItems from '@/modules/_global/mixins/list-items';

export default {
  name: 'InhabitantChangesList',

  filters: {
    dateFormat
  },

  mixins: [i18nRefreshData, listItems],

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('PROFILE.FIRST_NAME'),
          value: 'first_name'
        },
        {
          text: this.$t('PROFILE.LAST_NAME'),
          value: 'last_name'
        },
        {
          text: this.$t('PROFILE.STREET'),
          value: 'apartment.building.street'
        },
        {
          text: this.$t('APARTMENTS.ITEM'),
          value: 'apartment.name'
        },
        {
          text: this.$t('PROFILE.ZIP'),
          value: 'apartment.building.building_complex.zip'
        },
        {
          text: this.$t('PROFILE.CITY'),
          value: 'apartment.building.building_complex.city'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'apartment.building.building_complex.name'
        },
        {
          text: this.$t('INHABITANT_CHANGES.DATE_OF_REQUEST'),
          value: 'created_at'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type_id'
        },
        {
          text: this.$t('ORDERS.SOURCE'),
          value: 'source_id'
        },
        {
          text: this.$t('PROFILE.STATUS'),
          value: 'status_id'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  methods: {
    isEmptyObject(v) {
      return isEmpty(v);
    }
  }
};
</script>
